export enum EvaluativeParagraphSection {
  "header" = "header",
  "title" = "title",
  "body" = "body",
  "ignore" = "ignore",
}
